import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { makeStyles, Tooltip } from '@material-ui/core';
import { TextCollectionAttachment } from '@scale/shared/types/params/textcollection';
import { BoundingBox } from '@scale/shared/types/response/textcollection';
import EditableBoundingBox from './EditableBoundingBox';

const BOX_PADDING_RATIO = 1.2;

export default function BoundingBoxPreview(box: BoundingBox, attachment: TextCollectionAttachment) {
  const jpegUrl = attachment.jpegContent!;
  const [imageSize, setImageSize] = React.useState({ width: 1, height: 1 });
  React.useEffect(() => {
    const image = new Image();
    image.onload = function () {
      setImageSize({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    };
    image.src = jpegUrl;
  }, [jpegUrl]);

  const boxSize = Math.max(box.width, box.height) * BOX_PADDING_RATIO;
  const zoom = 500 / boxSize;

  const naturalOffsetX = box.left + box.width / 2 - boxSize / 2;
  const naturalOffsetY = box.top + box.height / 2 - boxSize / 2;

  const styles = useBoundingBoxPreviewStyles({
    jpegUrl: attachment.jpegContent!,
    offsetX: -naturalOffsetX * zoom,
    offsetY: -naturalOffsetY * zoom,
    imageWidth: imageSize.width * zoom,
    imageHeight: imageSize.height * zoom,
  });

  return (
    <Tooltip
      placement="left"
      classes={{ tooltip: styles.tooltip }}
      title={
        <EditableBoundingBox
          value={{
            ...box,
            left: box.left - naturalOffsetX,
            top: box.top - naturalOffsetY,
          }}
          onUpdate={() => {}}
          naturalWidth={boxSize}
          naturalHeight={boxSize}
          offsetWidth={500}
          offsetHeight={500}
        />
      }
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ verticalAlign: 'middle' }}
      >
        <g opacity="0.5">
          <path
            d="M12.8004 10.6221V5.37815C13.2766 5.1009 13.6004 4.5909 13.6004 4.00015C13.6004 3.1164 12.8841 2.40015 12.0004 2.40015C11.4096 2.40015 10.8994 2.7239 10.6224 3.20015H5.37839C5.10139 2.7239 4.59114 2.40015 4.00039 2.40015C3.11664 2.40015 2.40039 3.1164 2.40039 4.00015C2.40039 4.5909 2.72414 5.10115 3.20039 5.37815V10.6219C2.72414 10.8991 2.40039 11.4094 2.40039 12.0001C2.40039 12.8839 3.11664 13.6001 4.00039 13.6001C4.59114 13.6001 5.10139 13.2764 5.37839 12.8001H10.6221C10.8994 13.2764 11.4094 13.6001 12.0001 13.6001C12.8839 13.6001 13.6001 12.8839 13.6001 12.0001C13.6004 11.4094 13.2766 10.8991 12.8004 10.6221ZM4.80039 10.6221V5.37815C5.03998 5.23894 5.23918 5.03973 5.37839 4.80015H10.6221C10.7614 5.03973 10.9606 5.23894 11.2001 5.37815V10.6219C10.9606 10.7611 10.7614 10.9603 10.6221 11.1999H5.37839C5.23917 10.9604 5.03996 10.7613 4.80039 10.6221V10.6221ZM12.4004 4.00015C12.4004 4.22065 12.2209 4.40015 12.0004 4.40015C11.7799 4.40015 11.6004 4.22065 11.6004 4.00015C11.6004 3.77965 11.7799 3.60015 12.0004 3.60015C12.2209 3.60015 12.4004 3.77965 12.4004 4.00015ZM4.00039 3.60015C4.22089 3.60015 4.40039 3.77965 4.40039 4.00015C4.40039 4.22065 4.22089 4.40015 4.00039 4.40015C3.77989 4.40015 3.60039 4.22065 3.60039 4.00015C3.60039 3.77965 3.77989 3.60015 4.00039 3.60015ZM3.60039 12.0001C3.60039 11.7796 3.77989 11.6001 4.00039 11.6001C4.22089 11.6001 4.40039 11.7796 4.40039 12.0001C4.40039 12.2206 4.22089 12.4001 4.00039 12.4001C3.77989 12.4001 3.60039 12.2206 3.60039 12.0001ZM12.0004 12.4001C11.7799 12.4001 11.6004 12.2206 11.6004 12.0001C11.6004 11.7796 11.7799 11.6001 12.0004 11.6001C12.2209 11.6001 12.4004 11.7796 12.4004 12.0001C12.4004 12.2206 12.2209 12.4001 12.0004 12.4001Z"
            fill="black"
          />
        </g>
      </svg>
    </Tooltip>
  );
}

const useBoundingBoxPreviewStyles = makeStyles({
  tooltip: (params: {
    jpegUrl: string;
    offsetX: number;
    offsetY: number;
    imageWidth: number;
    imageHeight: number;
  }) => ({
    display: 'block',
    width: '500px',
    maxWidth: '500px',
    height: '500px',
    maxHeight: '500px',
    background: '#FFFFFF',
    backgroundImage: `url(${params.jpegUrl})`,
    backgroundPosition: `${params.offsetX}px ${params.offsetY}px`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `${params.imageWidth}px ${params.imageHeight}px`,
    boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.25)',
    borderRadius: '4px',
    color: '#000000',
    marginLeft: '0',
    marginRight: '0',
  }),
});
